import Skeleton from "@/common/components/Skeleton";

const CreateForwardingSelectDirectiveEntrySelectLoading = () => {
  return (
    <div className="p-4 rounded-lg bg-white-100 flex flex-col gap-2.5">
      <div className="flex items-center gap-2">
        <Skeleton className="size-4 rounded-full" />

        <Skeleton className="h-5 w-1/2" />
      </div>

      <div className="flex flex-col gap-3.5">
        <div className="flex flex-col gap-1">
          <Skeleton className="h-4" />

          <Skeleton className="h-4 w-1/2" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4" />

          <Skeleton className="h-4 w-2/3" />
        </div>

        <div className="flex flex-col gap-1">
          <Skeleton className="h-4" />

          <Skeleton className="h-4 w-1/3" />
        </div>
      </div>
    </div>
  );
}

export default CreateForwardingSelectDirectiveEntrySelectLoading;
